var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Accessibility_1;
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, number } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AccessibilityService, MessageService, ShortcutService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isFunction, isMobile, noop } from '@philips-internal/oswald-ui-utils';
import { Link } from '../link/link.js';
import { AccessibilityAPI } from './accessibility-api.js';
import './accessibility.css';
const { decreaseFontSize, getFontSize, increaseFontSize, isContrastEnabled, scrollToBottom, scrollToTop, setContrastEnabled, setFontSize, } = AccessibilityService;
function AccessibilityButton(props) {
    const { active, className, onClick, testId, value = '', xContrast } = props;
    const activeClass = active ? 'is-active' : '';
    return (React.createElement("button", { className: `c-accessibility__button ${className} ${activeClass}`, "data-testid": testId, onClick: onClick, type: "button", "x-contrast": xContrast }, value));
}
let Accessibility = Accessibility_1 = class Accessibility extends Component {
    constructor() {
        super(...arguments);
        this.unbindShortcuts = noop;
        this.state = {};
        this.handleShortcuts = (_evt, shortcut) => {
            const shortcutActions = {
                'alt+0': this.increaseFontSize,
                'alt+1': scrollToTop,
                'alt+4': scrollToBottom,
                'alt+6': this.resetContrast,
                'alt+7': this.enableContrast,
                'alt+8': this.decreaseFontSize,
                'alt+9': this.resetFontSize,
            }[shortcut.key];
            shortcutActions?.();
        };
        this.enableContrast = () => {
            if (!isContrastEnabled()) {
                setContrastEnabled(true);
            }
        };
        this.resetContrast = () => {
            if (isContrastEnabled()) {
                setContrastEnabled(false);
            }
        };
        this.toggleContrast = () => {
            setContrastEnabled(!isContrastEnabled());
        };
        this.increaseFontSize = () => {
            const { fontSizeStep = Accessibility_1.defaultProps.fontSizeStep, maxFontSize = Accessibility_1.defaultProps.maxFontSize, } = this.props;
            increaseFontSize(fontSizeStep, maxFontSize);
            this.updateFontSize();
        };
        this.decreaseFontSize = () => {
            const { fontSizeStep = Accessibility_1.defaultProps.fontSizeStep, minFontSize = Accessibility_1.defaultProps.minFontSize, } = this.props;
            decreaseFontSize(fontSizeStep, minFontSize);
            this.updateFontSize();
        };
        this.resetFontSize = () => {
            setFontSize(100);
            this.updateFontSize();
        };
    }
    componentDidMount() {
        if (!isMobile()) {
            const keys = 'alt+0, alt+1, alt+4, alt+6, alt+7, alt+8, alt+9';
            this.unbindShortcuts = ShortcutService.on(keys, this.handleShortcuts);
        }
    }
    componentWillUnmount() {
        if (isFunction(this.unbindShortcuts)) {
            this.unbindShortcuts();
        }
    }
    updateFontSize() {
        const fontSize = getFontSize();
        this.setState({ fontSize });
    }
    render() {
        const { onClick, onDoubleClick, onContextMenuClick } = this.props;
        const fontSize = getFontSize();
        return (React.createElement("div", { className: "c-accessibility", "x-contrast": "bg" },
            React.createElement(Link, { className: "c-accessibility__label", onClick: onClick, onContextMenuClick: onContextMenuClick, onDoubleClick: onDoubleClick, value: MessageService.translate('tws.accessibility.label') }),
            React.createElement(AccessibilityButton, { className: "--toggle-contrast", onClick: this.toggleContrast, testId: "accessibility-high-contrast", xContrast: "bd bg cl" }),
            React.createElement(AccessibilityButton, { active: fontSize < 100, className: "--font-dec", onClick: this.decreaseFontSize, testId: "accessibility-font-dec", value: "A-", xContrast: "bg" }),
            React.createElement(AccessibilityButton, { active: fontSize === 100, className: "--font-reset", onClick: this.resetFontSize, testId: "accessibility-font-reset", value: "A", xContrast: "bg" }),
            React.createElement(AccessibilityButton, { active: fontSize > 100, className: "--font-inc", onClick: this.increaseFontSize, testId: "accessibility-font-inc", value: "A+", xContrast: "bg" })));
    }
};
Accessibility.propTypes = {
    fontSizeStep: number,
    maxFontSize: number,
    minFontSize: number,
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
};
Accessibility.defaultProps = {
    fontSizeStep: 5,
    maxFontSize: 150,
    minFontSize: 70,
};
Accessibility = Accessibility_1 = __decorate([
    AwesomeComponent({ api: AccessibilityAPI, type: ComponentType.LAYOUT })
], Accessibility);
export { Accessibility, };
export default Accessibility;
//# sourceMappingURL=accessibility.js.map